import { naturalSort, reverseNaturalSort } from '@/helpers/util';

const formatter = 'stacked';

/**
 * Format result data that is in a timeseries format with an additional grouping
 *
 * @param {Kpi} kpi
 * @param {Array} resultData
 */
export default function formatStackedResults(kpi, resultData) {
  const displayType = kpi.getDisplayType();
  const displayData = [];

  const { data, meta: { typeY0 } } = resultData;
  // A stacked KPI can return an empty first result if there is no data, so we remove the empty
  // result to keep the normal chart behaviour of showing the "no data" overlay
  if (data.length === 1 && !data[0]?.x) {
    delete data[0];
  }

  const traceMap = data.reduce((tm, { x, y0, series }) => {
    tm[series] = tm[series] || []; // eslint-disable-line no-param-reassign
    tm[series].push({
      x,
      y: typeY0 === 'percentage' ? y0 / 100 : y0,
    });
    return tm;
  }, {});

  const isPercent = kpi.isPercent();
  const sort = kpi.getSort();
  const sortProperty = sort.by === 'metric' ? 'y' : 'x';

  // Map traces back to displayData
  const state = kpi.getState();
  let savedFalseTrace; // to preserve legacy colours
  Object.keys(traceMap).forEach((k) => {
    const dataItem = {
      key: kpi.getPropertyValueKey(kpi.grouping, k, true),
      type: kpi.getChartDisplayType(),
      values: traceMap[k],
    };

    if (displayType === 'line') {
      const { displayOptions: { hideLineMarkers } } = kpi;
      dataItem.mode = hideLineMarkers ? 'lines' : 'lines+markers';
    }

    const stateKey = dataItem.key;
    if (state[stateKey] && state[stateKey].visible === false) {
      dataItem.visible = false;
    }

    if (sort.order === 'desc') {
      dataItem.values = reverseNaturalSort(dataItem.values, sortProperty);
    } else {
      dataItem.values = naturalSort(dataItem.values, sortProperty);
    }

    if (k === 'false') {
      savedFalseTrace = dataItem;
    } else {
      displayData.push(dataItem);
    }
  });

  if (savedFalseTrace) {
    displayData.push(savedFalseTrace);
  }

  return {
    displayType,
    displayData,
    isPercent,
    formatter,
  };
}
